import LocalStorage from './localStorage';
import moment from 'moment';

export const getLoggedInUser = () => {
  const loginUser = LocalStorage.getItem('bbs_user') || '';
  const user = loginUser || { user: null };

  return {
    ...user,
    loggedIn: loginUser !== '',
  };
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const blobToFile = (blob, fileName) => {
  blob.lastModified = new Date().getTime();
  blob.name = fileName;

  return blob;
};

export const removeDuplicatesFromArray = (arr, key) => {
  const uniqueArr = [];

  const unique = arr.filter((item) => {
    const isDuplicate = uniqueArr.includes(item[`${key}`]);

    if (!isDuplicate) {
      uniqueArr.push(item[`${key}`]);

      return true;
    }

    return false;
  });

  return unique;
};

export function numFormating(value) {
  var val = Math.abs(value);
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(0) + 'Cr';
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(0) + 'Lac';
  } else if (val >= 1000) {
    val = Math.abs(val)?.toLocaleString(undefined, {
      maximumFractionDigits: 2,
    });
  }
  return val;
}

export const weighingRules = (ruleID, no_of_cont, weighing_cont) => {
  if (ruleID == 1) {
    if (weighing_cont == no_of_cont) {
      return true;
    }
  }
  if (ruleID == 2) {
    if (no_of_cont <= 5) {
      if (weighing_cont == no_of_cont) {
        return true;
      }
    }
    if (no_of_cont > 5 && no_of_cont <= 25) {
      if (weighing_cont == 6) {
        return true;
      }
    }
    if (no_of_cont > 25) {
      if (weighing_cont == Math.round(Math.sqrt(no_of_cont)) + 1) {
        console.log(Math.round(Math.sqrt(no_of_cont)));
        return true;
      }
    }
  }
  if (ruleID == 3) {
    if (weighing_cont >= 0) {
      return true;
    }
  }
};

export const weighingRulesCount = (ruleID, no_of_cont) => {
  if (ruleID == 1) {
    return no_of_cont;
  }
  if (ruleID == 2) {
    if (no_of_cont <= 5) {
      return no_of_cont;
    }
    if (no_of_cont > 5 && no_of_cont <= 25) {
      return 6;
    }
    if (no_of_cont > 25) {
      return Math.round(Math.sqrt(no_of_cont) + 1);
    }
  }
  if (ruleID == 3) {
    return 0;
  }
};

export const roles = (role, level) => {
  if (role == 'user' && level !== 3) {
    return 'Warehouse User';
  } else if (role == 'user' && level == 3) {
    return 'Warehouse Lead';
  }
  if (role == 'qc_initiator' && level !== 3) {
    return 'QA User';
  } else if (role == 'qc_initiator' && level == 3) {
    return 'QA Lead';
  }
  if ((role == 'qa-initiator' || role == 'qa_initiator') && level !== 3) {
    return 'QC User';
  } else if (role == 'qa_initiator' && level == 3) {
    return 'QC Lead';
  }
  if (role == 'prod_user' && level !== 3) {
    return 'Production User';
  } else if (role == 'prod_user' && level == 3) {
    return 'Production Lead';
  }
  if (role == 'admin') {
    return 'Admin';
  }
  if (role == 'ppic_user') {
    return 'PPIC User';
  }
};

export const getRoles = (role) => {
  const loginUser = LocalStorage.getItem('Gravity_user') || '';
  const user = loginUser || { user: null };
  const Superadmindata = user?.user?.qa_super_level.filter(
    (item) => item?.department == role,
  );
  return {
    Superadmindata,
  };
};

export const generateFinancialYears = (count) => {
  const currentYear = moment().year();
  const currentMonth = moment().month();
  const currentFinancialYearStart =
    currentMonth >= 3 ? currentYear : currentYear - 1;

  const financialYears = [];

  for (let i = 0; i < count; i++) {
    const startYear = currentFinancialYearStart - i;
    const endYear = startYear + 1;

    const startYearShort = startYear.toString().slice(2);
    const endYearShort = endYear.toString().slice(2);

    const quarters = [
      {
        title: `Q1 (1-Apr-${startYear} – 30-Jun-${startYear})`,
        completeQuarter: `FY${startYearShort}-${endYearShort} Q1(1-Apr-FY${startYearShort} to 30-Jun-FY${startYearShort})`,
      },
      {
        title: `Q2 (1-Jul-${startYear} – 30-Sep-${startYear})`,
        completeQuarter: `FY${startYearShort}-${endYearShort} Q2(1-Jul-FY${startYearShort} to 30-Sep-FY${startYearShort})`,
      },
      {
        title: `Q3 (1-Oct-${startYear} – 31-Dec-${startYear})`,
        completeQuarter: `FY${startYearShort}-${endYearShort} Q3(1-Oct-FY${startYearShort} to 31-Dec-FY${startYearShort})`,
      },
      {
        title: `Q4 (1-Jan-${endYear} – 31-Mar-${endYear})`,
        completeQuarter: `FY${startYearShort}-${endYearShort} Q4(1-Jan-FY${endYearShort} to 31-Mar-FY${endYearShort})`,
      },
    ];

    financialYears.push({
      title: `Financial Year ${startYear}-${endYear}`,
      shortHand: `FY${startYearShort} - ${endYearShort}`,
      completeYear: `FY${startYearShort}-${endYearShort} (1-APR-${startYearShort} to 31-MAR-${endYearShort})`,
      quarters,
    });
  }

  return financialYears.reverse();
};

export const generateFinancialMonths = (count) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const currentMonthIndex = moment().month();
  const currentYear = moment().year();
  const financialMonths = [];
  for (let i = 0; i < count; i++) {
    const monthIndex = (currentMonthIndex - i + 12) % 12;
    const year = currentYear - (currentMonthIndex - i < 0 ? 1 : 0);

    financialMonths.push({
      title: `${months[monthIndex]} ${year}`,
      shortHand: `${months[monthIndex]}`,
      complete: `${String(monthIndex + 1).padStart(2, '0')}-${year}`,
    });
  }

  return financialMonths.reverse();
};

export const generateLastMonthsOfQuarter = (count) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const quarterEndMonths = [2, 5, 8, 11];
  const currentMonthIndex = moment().month();
  const currentYear = moment().year();
  const financialMonths = [];

  let i = 0;
  while (financialMonths.length < count) {
    const monthIndex = (currentMonthIndex - i + 12) % 12;
    const year = currentYear - (currentMonthIndex - i < 0 ? 1 : 0);

    if (quarterEndMonths.includes(monthIndex)) {
      financialMonths.push({
        title: `${months[monthIndex]} ${year}`,
        shortHand: `${months[monthIndex]} (${year})`,
        complete: `${String(monthIndex + 1).padStart(2, '0')}-${year}`,
      });
    }
    i++;
  }

  return financialMonths.reverse();
};

export function transformMonthsToFinancialQuarters(dates) {
  let fyMap = new Map();

  dates.forEach((date) => {
    let [month, year] = date.split('-').map(Number);

    let fyStart, fyEnd;
    if (month >= 4) {
      fyStart = year;
      fyEnd = year + 1;
    } else {
      fyStart = year - 1;
      fyEnd = year;
    }

    let fyLabel = `FY${String(fyStart).slice(-2)}-${String(fyEnd).slice(-2)} (1-APR-${String(fyStart).slice(-2)} to 31-MAR-${String(fyEnd).slice(-2)})`;

    let quarterLabel;
    if ([4, 5, 6].includes(month)) {
      quarterLabel = `FY${String(fyStart).slice(-2)}-${String(fyEnd).slice(-2)} Q1(1-Apr-FY${String(fyStart).slice(-2)} to 30-Jun-FY${String(fyStart).slice(-2)})`;
    } else if ([7, 8, 9].includes(month)) {
      quarterLabel = `FY${String(fyStart).slice(-2)}-${String(fyEnd).slice(-2)} Q2(1-Jul-FY${String(fyStart).slice(-2)} to 30-Sep-FY${String(fyStart).slice(-2)})`;
    } else if ([10, 11, 12].includes(month)) {
      quarterLabel = `FY${String(fyStart).slice(-2)}-${String(fyEnd).slice(-2)} Q3(1-Oct-FY${String(fyStart).slice(-2)} to 31-Dec-FY${String(fyStart).slice(-2)})`;
    } else {
      quarterLabel = `FY${String(fyStart).slice(-2)}-${String(fyEnd).slice(-2)} Q4(1-Jan-FY${String(fyEnd).slice(-2)} to 31-Mar-FY${String(fyEnd).slice(-2)})`;
    }

    if (!fyMap.has(fyLabel)) {
      fyMap.set(fyLabel, new Set());
    }
    fyMap.get(fyLabel).add(quarterLabel);
  });
  let result = [...fyMap.entries()].map(([financialYear, quarters]) => ({
    financial_year: financialYear,
    quarters: [...quarters],
  }));

  return result;
}

export const getPreviousMonths = (monthStr) => {
  let [month, year] = monthStr.split('-').map(Number);
  let months = [];

  for (let i = 2; i >= 0; i--) {
    let newMonth = month - i;
    let newYear = year;

    if (newMonth <= 0) {
      newMonth += 12;
      newYear -= 1;
    }

    months.push(`${String(newMonth).padStart(2, '0')}-${newYear}`);
  }

  return months;
};

export const generateYearsWithMonths = (count) => {
  let currentYear = moment();
  let lastYears = [];

  for (let i = 0; i < count; i++) {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const year = currentYear.clone().subtract(i, 'years').format('YYYY');
    lastYears.push({
      title: year,
      shortHand: year,
      complete: year,
      months: months.map((month, i) => {
        return {
          title: month,
          complete: `${String(i + 1).padStart(2, '0')}-${year}`,
        };
      }),
    });
  }

  return lastYears;
};

export const getLastFinancialYear = () => {
  let lastQuarter = moment().quarter() - 1;
  if (lastQuarter < 1) {
    lastQuarter = 4;
  }

  let startOfLastQuarter = moment().quarter(lastQuarter).startOf('quarter');
  let endOfLastQuarter = moment().quarter(lastQuarter).endOf('quarter');

  const [year, startMonth, startDay] = startOfLastQuarter
    .format('YY-MMM-DD')
    .split('-');
  const [endMonth, endDay] = endOfLastQuarter.format('MMM-DD').split('-');

  if (lastQuarter === 1) {
    return {
      year: `FY${parseInt(year) - 1}-${parseInt(year)} (1-APR-${parseInt(year) - 1} to 31-MAR-${parseInt(year)})`,
      quarter: `FY${parseInt(year) - 1}-${parseInt(year)} Q4(${parseInt(startDay)}-${startMonth}-FY${parseInt(year)} to ${parseInt(endDay)}-${endMonth}-FY${parseInt(year)})`,
    };
  } else if (lastQuarter === 2) {
    return {
      year: `FY${parseInt(year)}-${parseInt(year) + 1} (1-APR-${parseInt(year)} to 31-MAR-${parseInt(year) + 1})`,
      quarter: `FY${parseInt(year)}-${parseInt(year) + 1} Q1(${parseInt(startDay)}-${startMonth}-FY${parseInt(year)} to ${parseInt(endDay)}-${endMonth}-FY${parseInt(year)})`,
    };
  } else if (lastQuarter === 3) {
    return {
      year: `FY${parseInt(year)}-${parseInt(year) + 1} (1-APR-${parseInt(year)} to 31-MAR-${parseInt(year) + 1})`,
      quarter: `FY${parseInt(year)}-${parseInt(year) + 1} Q2(${parseInt(startDay)}-${startMonth}-FY${parseInt(year)} to ${parseInt(endDay)}-${endMonth}-FY${parseInt(year)})`,
    };
  } else if (lastQuarter === 4) {
    return {
      year: `FY${parseInt(year)}-${parseInt(year) + 1} (1-APR-${parseInt(year)} to 31-MAR-${parseInt(year) + 1})`,
      quarter: `FY${parseInt(year)}-${parseInt(year) + 1} Q3(${parseInt(startDay)}-${startMonth}-FY${parseInt(year)} to ${parseInt(endDay)}-${endMonth}-FY${parseInt(year)})`,
    };
  }
};

export const getLastFinancialMonth = (months) => {
  let lastQuarter = moment().quarter() - 1;
  if (lastQuarter < 1) {
    lastQuarter = 4;
  }
  let endOfLastQuarter = moment().quarter(lastQuarter).endOf('quarter');
  const [year, month] = endOfLastQuarter.format('YYYY-MM').split('-');
  return `${month}-${year}`;
};

export const getListOfCurrentYearMonths = () => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const currentYr = moment().year();
  const currentMonth = moment().month();

  return months.map((month, monthIndex) => {
    return {
      title: `${months[monthIndex]} ${currentYr}`,
      shortHand: `${months[monthIndex]} (${currentYr})`,
      complete: `${String(monthIndex + 1).padStart(2, '0')}-${currentYr}`,
      disabled: monthIndex > currentMonth,
    };
  });
};

export const getCurrentMonth = () => {
  const currentYr = moment().year();
  const currentMonth = moment().month();

  return `${String(currentMonth + 1).padStart(2, '0')}-${currentYr}`;
};

export const getYears = () => {
  const startYear = 2024;
  const currentYear = moment().year();

  const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }
  return years;
};

export const getPreviousMonth = () => {
  const prevMonth = moment().subtract(1, 'months');
  const month = String(prevMonth.month() + 1).padStart(2, '0');
  const year = prevMonth.year();

  return `${month}-${year}`;
};


export const getListOfSelectedYearMonths = (year = moment().year()) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const currentYr = moment().year();
  const currentMonth = moment().month();

  return months.map((month, monthIndex) => {
    return {
      title: `${month} ${year}`,
      shortHand: `${month} (${year})`,
      complete: `${String(monthIndex + 1).padStart(2, '0')}-${year}`,
      disabled: year > currentYr || (year === currentYr && monthIndex > currentMonth),
    };
  });
};

